import 'prop-types';
import styled from 'styled-components';

var List = styled.ul.withConfig({
  displayName: "List",
  componentId: "sc-51x8o5-0"
})(["&&{border-radius:3px;list-style:none;margin:0;margin-bottom:0 !important;padding:0;text-align:left;white-space:nowrap;}&&:focus{outline:0;}"]);

export { List };
